import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { DateView, DisableKind } from 'src/core/ui/date.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { ProductServiceTypeEditorController } from 'src/app/products/product-service-types/parts/product-service-type-editor.controller';
import { SearchTaxonomies } from 'src/app/bookings/search/requests/search-taxonomy';

interface SearchTransferProps {
	currentSearch: SearchTransfer;
	fieldsTaxonomy: TaxonomicField[];
	onChangeCategory: (productCategoryId: number) => Promise<void>;
	setBusy(isBusy: boolean);
}

@observer
export class SearchTransferView extends React.Component<SearchTransferProps, {}> {
	constructor(props: Readonly<SearchTransferProps>) {
		super(props);
	}
	render(): React.ReactNode {
		if (this.props.currentSearch == null) {
			return null;
		}

		const model = this.props.currentSearch;
		return (
			<Row gutter={16}>
				<Col xs={24} lg={16}>
					<Row gutter={16}>
						<Col xs={24} lg={12}>
							<ProductCategoryEditorController
								mode="edit"
								onChanged={(value) => {
									if (value != null) {
										model.productCategoryId = value.id;
										model.productCategoryDisplayName = value.displayName;
										this.props.onChangeCategory(value.id);
									} else {
										model.productCategoryId = null;
										model.productCategoryDisplayName = null;
										model.productServiceTypeId = null;
										model.productServiceTypeDisplayName = null;
										this.props.onChangeCategory(null);
									}
								}}
								value={model.productCategoryId}
								productType={3}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<ProductServiceTypeEditorController
								categoryId={model.productCategoryId}
								mode={model.productCategoryId ? 'edit' : 'display'}
								onChanged={(value) => {
									model.productServiceTypeId = value != null ? value.id : null;
									model.productServiceTypeDisplayName = value != null ? value.displayName : null;
								}}
								value={model.productServiceTypeId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24}>
							<RegionEditorController
								mode="edit"
								onChanged={(value) => {
									model.regionId = value != null ? value.id : null;
									model.regionName = value != null ? value.displayName : null;

									model.fromPlaceId = null;
									model.fromPlace = null;
									model.toPlaceId = null;
									model.toPlace = null;
								}}
								value={model.regionId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<PlaceEditorController
								required={true}
								mode={model.regionId ? "edit" : "display"}
								label="Pick up"
								regionId={model.regionId}
								onChanged={(value) => {
									model.fromPlaceId = value != null ? value.id : null;
									model.fromPlace = value != null ? value.displayName : null;
								}}
								value={model.fromPlaceId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<PlaceEditorController
								required={true}
								mode={model.regionId ? "edit" : "display"}
								label="Drop off"
								regionId={model.regionId}
								onChanged={(value) => {
									model.toPlaceId = value != null ? value.id : null;
									model.toPlace = value != null ? value.displayName : null;
								}}
								value={model.toPlaceId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24}>
							<ProductEditorController
								mode="edit"
								label="Transfer"
								onChanged={(value) => {
									model.productId = value != null ? value.id : null;
									model.productName = value != null ? value.displayName : null;
								}}
								value={model.productId}
								productType={3}
								fromPlaceId={model.fromPlaceId}
								toPlaceId={model.toPlaceId}
								regionId={model.regionId}
								categoryId={model.productCategoryId}
								serviceId={model.productServiceTypeId}
								setBusy={this.props.setBusy}
								afterLoad={this.afterProductLoaded}
							/>
						</Col>
						<Col xs={24}>
							<hr />
							<SearchTaxonomies
								model={model}
								fieldsTaxonomy={this.props.fieldsTaxonomy}
								setBusy={this.props.setBusy}
							/>
						</Col>
					</Row>
				</Col>
				<Col xs={24} lg={8}>
					<Row gutter={16}>
						<Col xs={24} lg={12}>
							<DateView
								required={true}
								mode="edit"
								label="Pick up (date & time)"
								value={model.startDate}
								onChanged={newVal => {
									model.startDate = newVal;
								}}
								format="small-date"
								showTime={DisableKind.disableSeconds}
								dateUsage="utc"
							/>
						</Col>
						<Col xs={24} lg={12}>
							<DateView
								required={model.returnJourney}
								mode={model.returnJourney == true ? "edit" : "display"}
								label="Drop off (date & time)"
								value={model.returnDate}
								onChanged={newVal => {
									model.returnDate = newVal;
								}}
								format="small-date"
								showTime={DisableKind.disableSeconds}
								dateUsage="utc"
							/>
						</Col>
						<Col xs={24}>
							<BooleanView
								mode="edit"
								label="Return Journey"
								value={model.returnJourney}
								onChanged={newVal => {
									model.returnJourney = newVal;

								}}
							/>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	private afterProductLoaded = (selected: ProductSummary, options: ProductSummary[]) => {
		if (selected && options.every(e => e.id !== selected.id)) {
			this.props.currentSearch.productId = null;
			this.props.currentSearch.productName = null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/requests/search-transfer.view.tsx